import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'


const state = {
  token: getToken(),
  name: '',
  realname:'',
  avatar: '',
  roles: [],
  tenantId:null,
  currentDspMonth: null,
  currentSspMonth: null,
  currentReportMonth: null,
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_REALNAME: (state, realname) => {
    state.realname = realname
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_TENANTID: (state, tenantId) => {
    state.tenantId = tenantId
  },
  SET_CURRENTDSPMONTH: (state, currentDspMonth) => {
    state.currentDspMonth = currentDspMonth
  },
  SET_CURRENTSSPMONTH: (state, currentSspMonth) => {
    state.currentSspMonth = currentSspMonth
  },
  SET_CURRENTREPORTMONTH: (state, currentReportMonth) => {
    state.currentReportMonth = currentReportMonth
  }
}

const actions = {
  // 登录
  Login({ commit }, userInfo) {
    const username = userInfo.username.trim()
    return new Promise((resolve, reject) => {
      login(username, userInfo.password).then(response => {
        const data = response.data
        console.log("login", data);
        const tokenStr = "Bearer " + data.accessToken
        // console.log("tokenStr", tokenStr);
        setToken(tokenStr)
        commit('SET_TOKEN', tokenStr)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户信息
  async GetInfo({ commit, state }) {

    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roles, username, icon, introduction,realname,tenantId } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', username)
        commit('SET_REALNAME', realname)
        commit('SET_AVATAR', icon)
        commit('SET_TENANTID',tenantId)
        // commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
    

  },

  // 登出
  LogOut({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        // console.log("KKKKKK")
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 前端 登出
  FedLogOut({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}

